import { c as _c } from "react/compiler-runtime";
import { NextGenTokenRarityType } from "@/components/nextGen/nextgen_helpers";
import UserCICAndLevel from "@/components/user/utils/UserCICAndLevel";
import { ETHEREUM_ICON_TEXT, NEXTGEN_MEDIA_BASE_URL } from "@/constants";
import { NextGenToken } from "@/entities/INextgen";
import { cicToType, formatAddress, getRoyaltyImage } from "@/helpers/Helpers";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { TraitScore } from "./NextGenTokenAbout";
export function NextGenTokenImage(props) {
  const $ = _c(52);
  const isMobileScreen = useIsMobileScreen();
  let t0;
  if ($[0] !== props.show_original || $[1] !== props.token.image_url || $[2] !== props.token.thumbnail_url) {
    t0 = function getImageUrl() {
      if (props.show_original) {
        return props.token.image_url;
      }
      return props.token.thumbnail_url ?? props.token.image_url;
    };
    $[0] = props.show_original;
    $[1] = props.token.image_url;
    $[2] = props.token.thumbnail_url;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const getImageUrl = t0;
  let t1;
  if ($[4] !== props.show_owner_info || $[5] !== props.token.blur_price || $[6] !== props.token.id || $[7] !== props.token.level || $[8] !== props.token.me_price || $[9] !== props.token.normalised_handle || $[10] !== props.token.opensea_price || $[11] !== props.token.owner || $[12] !== props.token.rep_score || $[13] !== props.token.tdh) {
    t1 = function getOwnerInfo() {
      let ownerInfoDisplay;
      if (props.show_owner_info) {
        const cicType = cicToType(props.token.tdh + props.token.rep_score);
        const ownerInfo = <span className="d-flex align-items-center gap-2"><UserCICAndLevel level={props.token.level} cicType={cicType} color="black" />{props.token.normalised_handle ?? formatAddress(props.token.owner)}</span>;
        ownerInfoDisplay = <button style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          display: "flex"
        }} aria-label="More info" onClick={_temp}><FontAwesomeIcon height={18} icon={faInfoCircle} data-tooltip-id={`owner-info-${props.token.id}`} /><Tooltip id={`owner-info-${props.token.id}`} place="right" delayShow={250} style={{
            backgroundColor: "#1F2937",
            color: "white",
            padding: "4px 8px"
          }}><Container><Row className="pt-2 pb-2"><Col>{ownerInfo}</Col></Row><Row className="pt-1"><Col>Opensea:{" "}{props.token.opensea_price > 0 ? `${props.token.opensea_price} ${ETHEREUM_ICON_TEXT}` : "Not Listed"}</Col></Row><Row className="pt-1"><Col>Blur:{" "}{props.token.blur_price > 0 ? `${props.token.blur_price} ${ETHEREUM_ICON_TEXT}` : "Not Listed"}</Col></Row><Row className="pt-1"><Col>Magic Eden:{" "}{props.token.me_price > 0 ? `${props.token.me_price} ${ETHEREUM_ICON_TEXT}` : "Not Listed"}</Col></Row></Container></Tooltip></button>;
      }
      return ownerInfoDisplay;
    };
    $[4] = props.show_owner_info;
    $[5] = props.token.blur_price;
    $[6] = props.token.id;
    $[7] = props.token.level;
    $[8] = props.token.me_price;
    $[9] = props.token.normalised_handle;
    $[10] = props.token.opensea_price;
    $[11] = props.token.owner;
    $[12] = props.token.rep_score;
    $[13] = props.token.tdh;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  const getOwnerInfo = t1;
  let t2;
  if ($[15] !== props.rarity_type || $[16] !== props.show_last_sale || $[17] !== props.show_listing || $[18] !== props.show_max_sale || $[19] !== props.token) {
    t2 = function getExtraInfo() {
      let rarityDisplay;
      if (props.rarity_type) {
        const rarityType = props.rarity_type.toLowerCase();
        const score = rarityType as keyof NextGenToken;
        const rank = `${rarityType}_rank` as keyof NextGenToken;
        rarityDisplay = <TraitScore score={props.token[score] as number} rank={props.token[rank] as number} />;
      }
      let listingDisplay;
      if (props.show_listing) {
        listingDisplay = <span className="d-flex align-items-center gap-2"><span className="d-flex align-items-center">{props.token.price > 0 ? <><span className="font-smaller font-color-h">Listed for</span> {props.token.price} {ETHEREUM_ICON_TEXT}</> : "Not Listed"}</span>{props.token.opensea_price == props.token.price && props.token.opensea_royalty > 0 && <Image unoptimized={true} width={0} height={0} style={{
            height: "20px",
            width: "auto"
          }} src={`/${getRoyaltyImage(props.token.opensea_royalty / 100)}`} alt="pepe" className="cursor-pointer" />}{props.token.me_price == props.token.price && props.token.me_price > 0 && <Image unoptimized={true} width={0} height={0} style={{
            height: "20px",
            width: "auto"
          }} src={`/${getRoyaltyImage(props.token.me_royalty / 100)}`} alt="pepe" className="cursor-pointer" />}</span>;
      }
      let saleDisplay;
      if (props.show_max_sale || props.show_last_sale) {
        const display = props.show_max_sale ? "Max sale" : "Last sale";
        const value = props.show_max_sale ? props.token.max_sale_value : props.token.last_sale_value;
        const date = props.show_max_sale ? props.token.max_sale_date : props.token.last_sale_date;
        if (value && date) {
          saleDisplay = <span className="d-flex align-items-center"><span className="font-color-h font-smaller">{display}</span> <span className="d-flex gap-2"><span>{Number.parseFloat(value.toFixed(5)).toLocaleString()}{" "}{ETHEREUM_ICON_TEXT}</span><span>{new Date(date).toLocaleDateString()}</span></span></span>;
        } else {
          saleDisplay = <span>Not Sold</span>;
        }
      }
      return <span className="d-flex flex-column align-items-end gap-1">{rarityDisplay}{saleDisplay}{listingDisplay}</span>;
    };
    $[15] = props.rarity_type;
    $[16] = props.show_last_sale;
    $[17] = props.show_listing;
    $[18] = props.show_max_sale;
    $[19] = props.token;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  const getExtraInfo = t2;
  let t3;
  if ($[21] !== getExtraInfo || $[22] !== getImageUrl || $[23] !== getOwnerInfo || $[24] !== isMobileScreen || $[25] !== props.hide_info || $[26] !== props.info_class || $[27] !== props.is_fullscreen || $[28] !== props.rarity_type || $[29] !== props.show_last_sale || $[30] !== props.show_listing || $[31] !== props.show_max_sale || $[32] !== props.show_owner_info || $[33] !== props.token.name || $[34] !== props.token.normalised_id || $[35] !== props.token_art) {
    t3 = function getImage() {
      let height = "auto";
      if (props.token_art) {
        if (isMobileScreen) {
          height = "55vh";
        } else {
          height = "85vh";
        }
      } else {
        if (props.is_fullscreen) {
          height = "100vh";
        }
      }
      return <><span className="d-flex flex-column align-items-center justify-content-center" style={{
          overflow: "hidden",
          height
        }}><Image quality={100} priority={true} unoptimized={true} width="0" height="0" style={{
            height: "auto",
            width: "auto",
            maxHeight: "100%",
            maxWidth: "100%"
          }} src={getImageUrl()} alt={props.token.name} onError={_temp2} /></span>{!props.hide_info && <span className={`pt-1 d-flex align-items-center ${props.rarity_type || props.show_listing || props.show_max_sale || props.show_last_sale || props.show_owner_info ? "justify-content-between" : "justify-content-center"}`}><span className={props.info_class ?? ""}>#{props.token.normalised_id}</span><span className="d-flex align-items-center gap-2">{getExtraInfo()}{getOwnerInfo()}</span></span>}</>;
    };
    $[21] = getExtraInfo;
    $[22] = getImageUrl;
    $[23] = getOwnerInfo;
    $[24] = isMobileScreen;
    $[25] = props.hide_info;
    $[26] = props.info_class;
    $[27] = props.is_fullscreen;
    $[28] = props.rarity_type;
    $[29] = props.show_last_sale;
    $[30] = props.show_listing;
    $[31] = props.show_max_sale;
    $[32] = props.show_owner_info;
    $[33] = props.token.name;
    $[34] = props.token.normalised_id;
    $[35] = props.token_art;
    $[36] = t3;
  } else {
    t3 = $[36];
  }
  const getImage = t3;
  let t4;
  if ($[37] !== getImage || $[38] !== isMobileScreen || $[39] !== props.is_fullscreen || $[40] !== props.show_animation || $[41] !== props.token.animation_url || $[42] !== props.token.generator?.html || $[43] !== props.token.name) {
    t4 = function getContent() {
      if (props.show_animation && props.token.animation_url) {
        return <iframe style={{
          width: "100%",
          height: props.is_fullscreen ? "100vh" : isMobileScreen ? "60vh" : "85vh",
          marginBottom: "-8px"
        }} src={props.token.animation_url ?? props.token.generator?.html} title={props.token.name} />;
      } else {
        return getImage();
      }
    };
    $[37] = getImage;
    $[38] = isMobileScreen;
    $[39] = props.is_fullscreen;
    $[40] = props.show_animation;
    $[41] = props.token.animation_url;
    $[42] = props.token.generator?.html;
    $[43] = props.token.name;
    $[44] = t4;
  } else {
    t4 = $[44];
  }
  const getContent = t4;
  if (props.hide_link) {
    let t5;
    if ($[45] !== getContent) {
      t5 = getContent();
      $[45] = getContent;
      $[46] = t5;
    } else {
      t5 = $[46];
    }
    return t5;
  } else {
    const t5 = `/nextgen/token/${props.token.id}`;
    let t6;
    if ($[47] !== getContent) {
      t6 = getContent();
      $[47] = getContent;
      $[48] = t6;
    } else {
      t6 = $[48];
    }
    let t7;
    if ($[49] !== t5 || $[50] !== t6) {
      t7 = <Link href={t5} className="decoration-none scale-hover unselectable">{t6}</Link>;
      $[49] = t5;
      $[50] = t6;
      $[51] = t7;
    } else {
      t7 = $[51];
    }
    return t7;
  }
}
function _temp2(e_0) {
  e_0.currentTarget.src = "/pebbles-loading.jpeg";
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}
export function getNextGenImageUrl(tokenId: number) {
  return `${NEXTGEN_MEDIA_BASE_URL}/png/${tokenId}`;
}
export function getNextGenIconUrl(tokenId: number) {
  return `${NEXTGEN_MEDIA_BASE_URL}/thumbnail/${tokenId}`;
}
export function get8KUrl(tokenId: number) {
  return `${NEXTGEN_MEDIA_BASE_URL}/png8k/${tokenId}`;
}
export function get16KUrl(tokenId: number) {
  return `${NEXTGEN_MEDIA_BASE_URL}/png16k/${tokenId}`;
}